import { FC } from 'react';
import { Image, VStack } from '@chakra-ui/react';

import okHand from 'assets/brand/ok-hand.png';
import Text from 'components/_core/Text';

import { RequestsFilterState } from '../../types';
import locales from './locales';

interface NoRequestViewProps {
  requestState: RequestsFilterState;
}

const NoRequestView: FC<NoRequestViewProps> = ({ requestState }) => (
  <>
    <VStack alignItems="center" spacing="space-16">
      <Image
        alt=""
        height="90px"
        role="presentation"
        src={okHand}
        width="90px"
      />

      <VStack maxWidth={372} spacing="space-8">
        <Text fontWeight="weight-500" size="lg" variant="primary">
          {locales.title[requestState]}
        </Text>

        <Text align="center" variant="light">
          {locales.description}
        </Text>
      </VStack>
    </VStack>
  </>
);

export default NoRequestView;
